export default "__VITE_ASSET__SmMli3kb__"